import {copy} from '../site.js';
/** Accessible, stationary feedback shared by the cart and order form. */
export function createCartStatus(root) {
    const status = document.createElement('div');
    status.className = 'cart-status';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    const text = document.createElement('span');
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'cart-status-retry';
    retry.textContent = copy('Try again');
    retry.hidden = true;
    status.append(text, document.createTextNode(' '), retry);
    root.prepend(status);
    let message = '';
    const disabled = new Map();
    return {
        retry(handler) { retry.addEventListener('click', handler); },
        message(value) {
            message = value;
            text.textContent = value;
            status.classList.toggle('has-error', !!value);
            retry.hidden = !value;
        },
        busy(value) {
            if (value) {
                const activeRow = document.activeElement?.closest('.cart-item');
                const editor = root.querySelector('.mobile-variant-edit-screen.is-open');
                const editedRow = editor ? root.querySelector(`.cart-item[data-item-id="${Number(editor.dataset.currentEditId)}"]`) : null;
                const row = (activeRow && root.contains(activeRow) ? activeRow : editedRow)
                    || root.querySelector('.cart-item.is-cart-updating') || root.querySelector('.cart-item');
                if (row) row.classList.add('is-cart-updating');
            } else {
                root.querySelectorAll('.is-cart-updating').forEach(row => row.classList.remove('is-cart-updating'));
            }
            root.classList.toggle('is-cart-busy', value);
            root.setAttribute('aria-busy', String(value));
            status.classList.toggle('is-loading', value);
            text.textContent = value ? copy('Updating your cart…') : message;
            retry.disabled = value;
            if (value) {
                root.querySelectorAll('input, select, button').forEach(control => {
                    if (control === retry || disabled.has(control)) return;
                    disabled.set(control, control.disabled);
                    control.disabled = true;
                });
            } else {
                disabled.forEach((wasDisabled, control) => { control.disabled = wasDisabled; });
                disabled.clear();
            }
        }
    };
}
